import styled from 'styled-components'

export default styled.img`
  height: auto;
  width: 100%;
`
